/* eslint-disable global-require */
import { applyMiddleware, compose, createStore } from 'redux';
import * as Sentry from '@sentry/react';

import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import reducer from 'reduxStore/reducers';

export default (initialState) => {
  let store;
  const isClient = typeof window !== 'undefined';
  const sentryReduxEnhancer = Sentry.createReduxEnhancer();

  if (isClient) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const middlewares = composeEnhancers(applyMiddleware(thunk), sentryReduxEnhancer);
    const { persistReducer } = require('redux-persist');
    const storage = require('redux-persist/lib/storage').default;

    const persistConfig = {
      key: 'root',
      storage,
    };

    store = createStore(persistReducer(persistConfig, reducer), initialState, middlewares);

    store.__PERSISTOR = persistStore(store);
  } else {
    store = createStore(reducer, initialState, applyMiddleware(thunk));
  }

  return store;
};
